import { connect } from 'react-redux';
import { configSelector } from '../behaviors/configuration';
import { getCsrfToken } from '../behaviors/csrf-token';
import { getCustomerCode } from '../behaviors/customer-code';
import { searchSummarySelector } from '../behaviors/search-v9';
import DirectBooking from '../direct-booking';
import { productNameSelector } from '../behaviors/product-name';
import { settingsSelector } from '../behaviors/settings';

const mapStateToProps = (state, props) => {
  return {
    ...props,
    config: configSelector(state),
    customerCode: getCustomerCode(state),
    csrfToken: getCsrfToken(state),
    searchSummary: searchSummarySelector(state),
    productName: productNameSelector(state),
    appSettings: settingsSelector(state)
  };
};

const DirectBookingContainer = connect(mapStateToProps)(DirectBooking);
export default DirectBookingContainer;
